








import {Vue, Component, Prop} from 'vue-property-decorator';
import {multiNil, nil} from '@/common';

@Component({
    components: {},
})
export default class GlobalAlert extends Vue {
    public type: string = 'error';
    public dismissible: boolean = true;
    public text: string = '';
    public isHTML = false;
    public visible = false;
    public hide = true;
    public buttonLink = null;
    public buttonText = null;
    private get hasButton() {
        return !nil(this.buttonLink) && !nil(this.buttonText);
    }
    public mounted() {
        this.$bus.$on('showAlert', (params) => {
            this.text = params.text;
            this.type = params.type;
            this.isHTML = params.isHTML || false;
            if (!multiNil(params, 'button.link') && !multiNil(params, 'button.text')) {
                this.buttonLink = params.button.link;
                this.buttonText = params.button.text;
            } else {
                this.buttonLink = null;
                this.buttonText = null;
            }
            this.visible = true;
            setTimeout(() => {
                this.visible = false;
            }, params.timeout || 3500);
        });
    }
}
